import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("csc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Branch switcher: super_admin can pick "all" or a specific branch id.
  // We inject it on GET queries so every dashboard/table reflects the picked scope.
  try {
    const activeBranch = localStorage.getItem("csc_active_branch"); // "" | "all" | <branchId>
    if (activeBranch && (config.method || "get").toLowerCase() === "get") {
      config.params = { ...(config.params || {}) };
      if (!("branch_id" in config.params)) config.params.branch_id = activeBranch;
    }
  } catch { /* localStorage unavailable */ }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path !== "/login") {
        localStorage.removeItem("csc_token");
        localStorage.removeItem("csc_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function inr(n) {
  const v = Number(n || 0);
  return "\u20B9" + v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
